import { createContext, ReactNode, useContext } from 'react'

import { getPlacement } from './registry'
import type { AssistantPlacement } from './types'

/**
 * The placement a panel is shown in. Nothing provides it for the drawer and the standalone page:
 * they are the 'default-drawer' placement. An embed (e.g. the Case history pane) provides its
 * own, and the header, the empty chat and the composer read what they show from it.
 */
const AssistantPlacementContext = createContext<AssistantPlacement | null>(null)

export const AssistantPlacementProvider = ({
  placement,
  children,
}: {
  placement: AssistantPlacement
  children: ReactNode
}) => (
  <AssistantPlacementContext.Provider value={placement}>
    {children}
  </AssistantPlacementContext.Provider>
)

/** The placement of the panel this component is in; 'default-drawer' outside any provider. */
export const useAssistantPlacement = (): AssistantPlacement =>
  useContext(AssistantPlacementContext) ?? getPlacement('default-drawer')

export default AssistantPlacementContext
